// PRD.300 — reusable per-user UI preference storage.
//
// One row per `(org_id, user_id, preference_key)`. The payload is opaque JSON
// so future UI preferences reuse this table instead of adding one-off columns
// to `users` or growing another feature-specific settings table.
//
// Absence of a row is meaningful: it means "this user follows the clinic
// default". Never write a derived default here — see visit-note-preferences.ts.

import type { QuerySpec } from '@helios/powersync-client-core';

/**
 * Deterministic row id, so an upsert from two devices converges on ONE row
 * instead of racing to insert duplicates (the failure mode the older
 * `encounter_tab_settings` table has, which has no unique key).
 */
export function userUiPreferenceId(orgId: string, userId: string, preferenceKey: string): string {
  return `${orgId}:${userId}:${preferenceKey}`;
}

/** A single preference row for the signed-in user in the active org. */
export function qUserUiPreference(
  orgId: string,
  userId: string,
  preferenceKey: string,
): QuerySpec<[string, string, string]> {
  return {
    key: ['user_ui_preferences', orgId, userId, preferenceKey] as const,
    sql: `SELECT * FROM user_ui_preferences
           WHERE org_id = ? AND user_id = ? AND preference_key = ?
           LIMIT 1`,
    params: [orgId, userId, preferenceKey],
    watch: ['user_ui_preferences'],
  };
}
